import { Tooltip } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import {
  alertCircleIcon,
  pauseBotV2,
  startBotV2,
  stopBotV2,
} from "assets/icons/index";

const renderTooltip = (props) => (
  <Tooltip
    id="button-tooltip"
    {...props}
    className="tooltip-wrapper"
    tooltipClassName="v2-tooltip"
  >
    <div className="action-details">
      <div className="action-name">
        <img src={startBotV2} />
        <p>Begin live trading on this account</p>
      </div>
      <div className="action-name">
        <img src={pauseBotV2} />
        <p>Pause live trading on this account</p>
      </div>
      <div className="action-name">
        <img src={stopBotV2} />
        <p>Remove strategy from this account</p>
      </div>
    </div>
  </Tooltip>
);

renderTooltip.displayName = "renderTooltip";

export const TooltipIcon = () => {
  return (
    <>
      <OverlayTrigger
        placement="top"
        delay={{ show: 100, hide: 200 }}
        overlay={renderTooltip}
      >
        <img src={alertCircleIcon} className="info-icon" />
      </OverlayTrigger>
    </>
  );
};
